import { render } from "./contentManage.vue?vue&type=template&id=34979673"
import script from "./contentManage.vue?vue&type=script&lang=js"
export * from "./contentManage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contentCenter/contentManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34979673"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34979673', __exports__)) {
    console.log('reload')
    api.reload('34979673', __exports__)
  }
  
  module.hot.accept("./contentManage.vue?vue&type=template&id=34979673", () => {
    console.log('re-render')
    api.rerender('34979673', render)
  })

}


export default __exports__